import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

import { Room, useRooms } from '@/store/rooms';
	import { computed } from 'vue';
	import { usePubHubs } from '@/core/pubhubsStore';
	import { useUserColor } from '@/composables/useUserColor';
	import { useUserName } from '@/composables/useUserName';
	import { useUserAvatar } from '@/composables/useUserName';
	type Props = {
		userId: string;
		img?: string;
		notMention?: boolean;
	};

	
export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    userId: {},
    img: { default: '' },
    notMention: { type: Boolean, default: false }
  },
  setup(__props: any) {

	const { color, bgColor } = useUserColor();
	const { getUserDisplayName } = useUserName();
	const rooms = useRooms();
	const pubhubs = usePubHubs();

	const props = __props;

	const avatar = computed(() => {
		const currentRoom = rooms.currentRoom;
		if (currentRoom) {
			const { getUserAvatar } = useUserAvatar();
			return getUserAvatar(props.userId, rooms.currentRoom as Room);
		}
		return null;
	});

	const image = computed(() => {
		if (props.img) {
			return props.img;
		}
		return avatar.value ? pubhubs.getBaseUrl + '/_matrix/media/r0/download/' + avatar.value.slice(6) : '';
	});

	const display = computed(() => {
		let name = '' + props.userId;

		if (rooms.currentRoom && !props.notMention) {
			const currentRoom = rooms.currentRoom;
			name = getUserDisplayName(props.userId, currentRoom);
		}
		if (!name) {
			// IT should not happen, but just in case we should be only the lookout if it happens.
			// Debugging trace to check this.s
			console.trace('`name` argument to `getInitialLetter` not supplied', name, props.userId);
			return undefined;
		}
		if (name.length < 1) {
			return undefined;
		}

		const initial = name[0];
		if ((initial === '@' || initial === '#' || initial === '+') && name[1]) {
			name = '@';
		} else {
			name = initial;
		}

		return name.toUpperCase();
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-full w-12 h-12 flex items-center justify-center overflow-hidden", _unref(bgColor)(_unref(color)(_ctx.userId))])
  }, [
    (image.value !== '')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: image.value,
          class: "rounded-full w-full h-full"
        }, null, 8, _hoisted_1))
      : (display.value === '@')
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            type: "person",
            class: "right-0 group-hover:block h-16 w-16"
          }))
        : (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(_unref(rooms).currentRoom === undefined ? 'text-center text-5xl' : 'text-center text-2xl')
          }, _toDisplayString(display.value), 3))
  ], 2))
}
}

})